<template>
  <div class="uk-card uk-card-default uk-card-small uk-box-shadow-small">
    <div class="uk-card-header">
      <div class="uk-grid uk-grid-small">
        <div class="uk-width-auto"><h4>Offene Posten</h4></div>
      </div>
    </div>
    <div class="uk-card-body uk-padding-remove">
      <div class="uk-padding-small">
        <div class="uk-grid uk-grid-small uk-flex uk-flex-middle">
          <div class="uk-width-auto">
            <div class="uk-grid uk-grid-small uk-flex uk-flex-middle" data-uk-grid>
              <div class="uk-width-medium@m">
                <merchant-search
                  @selected="onMerchantSelected"
                  :value="$route.query.merchantNumber"
                  :update-route="false"
                ></merchant-search>
              </div>
            </div>
          </div>
          <div class="uk-width-expand" v-if="meta && meta.pagination.total_pages > 1">
            <pagination
              :pagination="meta.pagination"
              @pagination:switched="onPaginationSwitch"
              :update-route="false"
            ></pagination>
          </div>
        </div>
      </div>
      <div class="uk-overflow-auto">
        <table v-if="sales.length" class="uk-table uk-table-divider uk-table-small uk-table-middle uk-table-striped">
          <thead>
            <tr>
              <th class="uk-table-shrink">#</th>
              <th class="uk-table-expand">Name</th>
              <th class="uk-table-shrink">Betrag</th>
              <th class="uk-table-shrink">Datum</th>
              <th style="width:25px;" class="uk-text-right"></th>
            </tr>
          </thead>
          <tbody>
            <template v-for="sale in sales">
              <tr v-for="(item, key) in sale.items" :key="item.id">
                <td v-if="key == 0">
                  {{ sale.number }}
                </td>
                <td v-else>&nbsp;</td>
                <td v-if="key == 0" class="uk-text-nowrap">{{ sale.details.company }}</td>
                <td v-else>&nbsp;</td>
                <td>
                  {{ sale.amount | euro }}
                </td>
                <td class="uk-text-nowrap">{{ sale.date }}</td>
                <td class="uk-text-nowrap" v-if="key == 0">
                  <router-link
                    data-uk-icon="arrow-right"
                    data-uk-tooltip="Bestellung ansehen"
                    :to="{ name: 'admin.order.details', params: { id: sale.id } }"
                  >
                  </router-link>
                </td>
                <td v-else>&nbsp;</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="uk-padding-small uk-margin-bottom" v-if="meta && meta.pagination.total_pages > 1">
        <div class="uk-grid" data-uk-grid>
          <div class="uk-width-expand">
            <pagination
              :pagination="meta.pagination"
              @pagination:switched="onPaginationSwitch"
              :update-route="false"
            ></pagination>
          </div>
        </div>
      </div>
      <div class="uk-padding-small" v-if="!sales.length">
        <div class="uk-h5 uk-margin-remove">Keine offenen Posten</div>
      </div>
    </div>
  </div>
</template>
<script>
import MerchantSearch from '@/components/MerchantSearch'
import saleService from '@/services/sale.service'
import Pagination from '@/components/Pagination'
export default {
  data() {
    return {
      selectedMerchant: null,
      meta: null,
      sales: [],
    }
  },
  components: { MerchantSearch, Pagination },
  mounted() {
    this.getList()
  },
  methods: {
    async getList(query) {
      const sales = await saleService.getOpenInvoices({ ...query })
      this.sales = sales.data.sales
      this.meta = sales.data.meta
    },
    onMerchantSelected(merchant) {
      this.getList({ merchantNumber: merchant.number })
      this.selectedMerchant = merchant.number
    },
    onPaginationSwitch(page) {
      this.getList({ page: page, merchantNumber: this.selectedMerchant })
    }
  }
}
</script>
